export class TimeoutScheduler {
  timeoutId: number | null = null
  startTime: number = 0
  timeout: number = 0
  onTimeout: (secondsFromStart: number) => void

  constructor(onTimeout: (secondsFromStart: number) => void, timeout: number) {
    this.onTimeout = onTimeout
    this.timeout = timeout
  }

  start() {
    this.startTime = Date.now()
    this.run()
  }

  stop() {
    this.clear()
  }

  resume() {
    this.run()
  }

  run() {
    this.timeoutId = window.setTimeout(() => {
      this.onTimeout((Date.now() - this.startTime) / 1000)
    }, this.timeout)
  }

  clear() {
    if (this.timeoutId) {
      window.clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
  }
}
